import 'semantic-ui-less/definitions/elements/label.less';import _default from './Label';
export { _default as default };